module.exports = __webpack_public_path__ + "img/Star.1d3855ff.svg";